import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Module1 from "./pages/Module1";
import Module2 from "./pages/Module2";
import Module3 from "./pages/Module3";
import Module4 from "./pages/Module4";
import Module5 from "./pages/Module5";
import Module6 from "./pages/Module6";
import Navbar from "./components/Navbar";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/modulo-1" element={<Module1 />} />
          <Route path="/modulo-2" element={<Module2 />} />
          <Route path="/modulo-3" element={<Module3 />} />
          <Route path="/modulo-4" element={<Module4 />} />
          <Route path="/modulo-5" element={<Module5 />} />
          <Route path="/modulo-6" element={<Module6 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
